import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaResposta = (): TabelaColuna => ({
  Chave: 'resposta',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Resposta</div>
})
